export const GENERATE_IMAGE_STYLES = [
  'Bold & Energetic',
  'Bright & Fun',
  'Clean & Professional',
  'Elegant & Premium',
  'Faith-Inspired',
  'Minimal',
  'Modern Abstract',
  'Patriotic',
  'Seasonal',
  'Warm & Friendly',
];

export const GENERATE_IMAGE_HOLIDAY_THEMES = [
  'April Fools Day',
  'Black Friday',
  'Christmas',
  'Cinco de Mayo',
  'Cyber Monday',
  'Earth Day',
  'Easter',
  'Father\'s Day',
  'Flag Day',
  'Good Friday',
  'Groundhog Day',
  'Halloween',
  'Independence Day',
  'Labor Day',
  'Mardi Gras',
  'Martin Luther King Day',
  'Memorial Day',
  'Mother\'s Day',
  'New Year',
  'Patriot Day 9/11',
  'Presidents Day',
  'St. Patrick\'s Day',
  'Thanksgiving',
  'Valentine\'s Day',
  'Veterans Day',
];

export const GENERATE_IMAGE_INDUSTRY_THEMES = [
  'Automotive',
  'Banking',
  'Casino',
  'Cleaning Services',
  'Construction',
  'Credit Unions',
  'Dining',
  'Education',
  'Entertainment',
  'Freight',
  'General',
  'Health',
  'Holidays',
  'Insurance',
  'Law',
  'Liquor Store',
  'Pawn',
  'Political',
  'Public Service',
  'Real Estate',
  'Retail',
  'Roofing',
  'Shipping',
  'Sports',
  'Storage',
  'Veterinary Clinics',
];

export const GENERATE_IMAGE_RELIGIOUS_THEMES = [
  'Buddhist',
  'Catholic',
  'Christianity',
  'Hinduism',
  'Islam',
  'Judaism',
];

const toOption = (category) => (value) => ({value, label: value, category});

export const GENERATE_IMAGE_THEME_OPTIONS = [
  {label: 'Holiday', options: GENERATE_IMAGE_HOLIDAY_THEMES.map(toOption('Holiday'))},
  {label: 'Industry', options: GENERATE_IMAGE_INDUSTRY_THEMES.map(toOption('Industry'))},
  {label: 'Religious', options: GENERATE_IMAGE_RELIGIOUS_THEMES.map(toOption('Religious'))},
];

export const GENERATE_IMAGE_TEXT_PLACEMENT_OPTIONS = [
  'Center',
  'Left',
  'Right',
  'Top',
  'Bottom',
];

export const GENERATE_IMAGE_CONTENT_DENSITY_OPTIONS = [
  'Very Clean',
  'Balanced',
  'More Decorative',
];

export const GENERATE_IMAGE_DEFAULT_AVOID_ITEMS = [
  'people',
  'faces',
  'logos',
  'readable text',
  'letters',
  'numbers',
  'watermarks',
  'signs within the image',
  'overly cluttered details',
];
